import { render, staticRenderFns } from "./app.vue?vue&type=template&id=98619708&scoped=true&"
import script from "./app.vue?vue&type=script&lang=ts&setup=true&"
export * from "./app.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./app.vue?vue&type=style&index=0&id=98619708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98619708",
  null
  
)

export default component.exports